<template>
    <div class="page page--account">
        <div :class="$route.params.id ? 'container-fluid' : 'container'">
            <header class="page__heading page__heading--first d-print-none">
                <div class="page__heading-inner">
                    <h1 class="page__heading-title">Orders</h1>
                </div>
                <AccountManager class="h-hidden-xs"/>
            </header>
            <OrderList :class="{'has-sidebar-open': $route.params.id}" class="d-print-none"/>
            <transition name="slideFadeHorizontal" mode="out-in">
                <div class="sidebar sr-scrollbar m-print-0" v-if="$route.params.id" :style="marginTop">
                    <button @click="closeSidebar" class="btn btn-sm mb-2 text-muted d-print-none">
                        <i class="material-icons">close</i>
                    </button>
                    <div v-if="order">
                        <CartDetails :order="order" :is-editable="false"/>
                        <CartSummary :order="order" class="mt-5"/>
                        <CartCertificates class="d-print-none"/>
                    </div>
                    <div v-else>
                        Order is loading...
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import OrderList from '../../components/orders/OrdersList';
import AccountManager from '../../components/company/AccountManager';
import CartDetails from '../../components/cart/CartDetails';
import CartSummary from '../../components/cart/CartSummary';
import CartCertificates from '../../components/cart/CartCertificates';

export default {
  components: {
    OrderList,
    CartDetails,
    AccountManager,
    CartSummary,
    CartCertificates,
  },
  mounted() {
    this.bodyNoScroll();
    this.getOrder();
  },
  computed: {
    ...mapState({
      navbarHeight: state => state.navbar.navbarHeight,
    }),
    ...mapGetters({
      order: 'orders/order',
      navbarsHeight: 'navbar/navbarsHeight',
    }),
    marginTop() {
      return { marginTop: `${this.navbarsHeight}px` };
    },
  },
  watch: {
    '$route.params.id'() {
      this.getOrder();
      this.bodyNoScroll();
    },
  },
  methods: {
    getOrder() {
      return this.$route.params.id ? this.$store.dispatch('orders/getUserOrder', this.$route.params.id) : null;
    },
    bodyNoScroll() {
      const classes = ['h-scroll-disabled', 'h-scroll-disabled--hide-scrollbar'];
      return this.$route.params.id
        ? document.body.classList.add(...classes)
        : document.body.classList.remove(...classes);
    },
    closeSidebar() {
      this.$store.commit('orders/orderId', null);
      this.$router.push({ name: 'orders' });
    },
  },
};
</script>
